import Vue from 'vue'

import VueLazyBackgroundImage from 'vue-lazy-background-images/VueLazyBackgroundImage'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'leaflet/dist/leaflet.css';

import '@/plugins/loadslash'
import {
  store,
  vuetify,
  router,
  localStorage
} from '@/plugins'

import App from '@/App.vue'

// import Multiselect from 'vue-multiselect'
//import vueScrollBehavior from 'vue-scroll-behavior'
//Vue.use(vueScrollBehavior, { router: router })

Vue.config.productionTip = false
Vue.component('lazy-background', VueLazyBackgroundImage)
// Vue.component('multiselect', Multiselect)

new Vue({
  render: h => h(App),
  vuetify,
  router,
  store,
  localStorage
}).$mount('#app')
